// extracted by mini-css-extract-plugin
module.exports = {"LPPage":"GitHubActions_LPPage__39C8K","contents":"GitHubActions_contents__15wex","contact_wrapper":"GitHubActions_contact_wrapper__2QfLt"};